import { render, staticRenderFns } from "./thirdPartyDetailsAssocTabComponent.vue?vue&type=template&id=36ba5b04&scoped=true"
import script from "./thirdPartyDetailsAssocTabComponent.vue?vue&type=script&lang=js"
export * from "./thirdPartyDetailsAssocTabComponent.vue?vue&type=script&lang=js"
import style0 from "./thirdPartyDetailsAssocTabComponent.vue?vue&type=style&index=0&id=36ba5b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ba5b04",
  null
  
)

export default component.exports